
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    imgError($event) {
      $event.target.src =
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg'
      $event.target.srcset = this.$utils.genImgSrcSet(
        'https://ofm-cdn0.ofm.co.th/images/image-product-default-thumbnail.jpg',
        [{ w: 54, h: 54, q: 90, ws: '60w' }]
      )
    },
  },
}
